import { Layout } from "@Components/Layout";
import dynamic from "next/dynamic";
const Careers = dynamic(() => import("@Components/Pages/Pre-Footer/Careers"));

const CareersPage = () => {
  return (
    <Layout>
      <Careers />
    </Layout>
  );
};
export default CareersPage;
